import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initTabs();
    this.initSwiper();
  }

  initSwiper() {
    const sliderEl = this.querySelector<HTMLElement>('.swiper');
    if (!sliderEl) return;

    const prevEl = this.querySelector<HTMLElement>('.swiper-button-prev');
    const nextEl = this.querySelector<HTMLElement>('.swiper-button-next');

    new Swiper(sliderEl, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
    });
  }

  initTabs() {
    const buttons = this.querySelectorAll<HTMLElement>('[role="tab"]');
    const panels = this.querySelectorAll<HTMLElement>('[role="tabpanel"]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('aria-controls');
        
        // Deselect all buttons
        buttons.forEach((btn) => {
          btn.setAttribute('aria-selected', 'false');
          btn.classList.remove('product-main-v2__tabs-btn--active');
        });

        // Hide all panels
        panels.forEach((panel) => {
          panel.hidden = true;
          panel.classList.remove('product-main-v2__tabs-pane--active');
        });

        // Select clicked button
        button.setAttribute('aria-selected', 'true');
        button.classList.add('product-main-v2__tabs-btn--active');

        // Show target panel
        if (targetId) {
            const targetPanel = this.querySelector<HTMLElement>(`#${targetId}`);
            if (targetPanel) {
                targetPanel.hidden = false;
                targetPanel.classList.add('product-main-v2__tabs-pane--active');
            }
        }
      });
    });
  }
}
